import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const articleBlocks = {
  fetchBlocks: lazyModuleMethod(() => import('./fetchBlocks'), 'default'),
  fetchBlock: lazyModuleMethod(() => import('./fetchBlock'), 'default'),
  fetchBlockByExternalId: lazyModuleMethod(
    () => import('./fetchBlockByExternalId'),
    'default'
  ),
  deleteBlock: lazyModuleMethod(() => import('./deleteBlock'), 'default'),
  updateBlock: lazyModuleMethod(() => import('./updateBlock'), 'default'),
  createBlock: lazyModuleMethod(() => import('./createBlock'), 'default'),
  createBlocks: lazyModuleMethod(() => import('./createBlocks'), 'default'),
  rollbackRichHtmlBlocks: lazyModuleMethod(
    () => import('./rollbackRichHtmlBlocks'),
    'default'
  ),
}
